// extracted by extract-css-chunks-webpack-plugin
module.exports = {"catalog-page":"catalog-page___uftzL","paginate":"paginate___2NB3r","grid":"grid___1RKS3"};